export enum PagesUrl {
  CAUSES = '/causes',
  HOME = '/',
}

export enum MOBILE_ROUTES {
  native = '/native',
}

export enum APP_LINKS {
  android_scheme = 'givebacks:///native',
}
